import { localisedValue } from "utils"

const staffRolesTransformer = resp => {
  return resp?.data?.map(item => {
    return {
      ...item,
      value: item.id.toString(),
      label: localisedValue({ object: item, key: "name" }),
    }
  })
}

export default staffRolesTransformer
